/** Keep a post-login destination inside the portal, without routing back into auth. */
export function safePortalRedirect(value: unknown): string {
  const target = Array.isArray(value) ? value[0] : value
  if (typeof target !== 'string' || !target.startsWith('/') || target.startsWith('//')
    || /[\\\u0000-\u001f\u007f]/.test(target)) return '/'
  try {
    const url = new URL(target, 'https://portal.invalid')
    if (url.origin !== 'https://portal.invalid' || /^\/(?:login|activate|forbidden)(?:\/|$)/.test(url.pathname)) return '/'
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return '/'
  }
}
